import { createSlice } from '@reduxjs/toolkit';
import VwMbsMuhasebeislemdetayDTO from 'src/models/MuhasebeIslemler/VwMbsMuhasebeislemdetayDTO';
import VwMbsMuhasebeislemDTO from 'src/models/MuhasebeIslemler/VwMbsMuhasebeislemDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { helper } from 'src/utils/helper';

export class YilOrgClass {
    yil: number;
    organizasyonId: number;
    organizasyonAd: string;
}
export class YilOrganizasyonSecim extends YilOrgClass {
    yilOrgSecimDiaogOpen: boolean = true;

}
export class MuhasebeIslemlerSearch {
    baslangicTarih: string = helper.startDate();
    bitisTarih: string = helper.endDate();
    cariKod: number = null;
    fisTur: number = null;
    yevmiyeNo: number = null;
    yil: number = null;
    organizasyonId: number = null;
}
export class IptalObject {
    open: boolean;
    row: VwMbsMuhasebeislemDTO | VwMbsMuhasebeislemdetayDTO;
}
export interface IMuhasebeIslemlerState {
    yilOrgObject: YilOrganizasyonSecim;

    searchModel: MuhasebeIslemlerSearch;
    submitForm: boolean;
    activeDetayRow: VwMbsMuhasebeislemDTO;
    editedMuhasebeIslemDetays: Array<VwMbsMuhasebeislemdetayDTO>;
    iptalObject: IptalObject;
}

const MuhasebeIslemlerSlice = createSlice<
    IMuhasebeIslemlerState,
    MapReducerPayloads<
        IMuhasebeIslemlerState,
        {
            setYilOrgObject: YilOrganizasyonSecim;
            setSearchModel: MuhasebeIslemlerSearch;
            setSubmitForm: boolean;
            setActiveDetayRow: VwMbsMuhasebeislemDTO;
            setEditedMuhasebeIslemDetays: Array<VwMbsMuhasebeislemdetayDTO>;
            setIptalNedenObject: IptalObject;
        }
    >
>({
    name: 'muhasebeIslemler',
    initialState: {
        yilOrgObject: new YilOrganizasyonSecim(),
        searchModel: new MuhasebeIslemlerSearch(),
        submitForm: false,
        activeDetayRow: new VwMbsMuhasebeislemDTO(),
        editedMuhasebeIslemDetays: new Array<VwMbsMuhasebeislemdetayDTO>(),
        iptalObject: new IptalObject()
    },
    reducers: {
        setYilOrgObject: (state, action) => {
            state.yilOrgObject = action.payload;
        },
        setSearchModel: (state, action) => {
            state.searchModel = action.payload;
        },
        setSubmitForm: (state, action) => {
            state.submitForm = action.payload;
        },
        setActiveDetayRow: (state, action) => {
            state.activeDetayRow = action.payload;
        },
        setEditedMuhasebeIslemDetays: (state, action) => {
            state.editedMuhasebeIslemDetays = action.payload;
        },
        setIptalNedenObject: (state, action) => {
            state.iptalObject = action.payload;
        },
    }
});
export default MuhasebeIslemlerSlice;
